/**
 * Debug logger utility for component debugging
 */

// Set to false to disable all debug logging
const DEBUG_ENABLED = false;

// Enable specific component debug logs (even when DEBUG_ENABLED is false)
const DEBUG_COMPONENTS: Record<string, boolean> = {
  'FleetVisualization': false,
  'MiningZoneSelector': false,
  'miningZoneService': false,
  'FleetPanel': false
};

/**
 * Log debug messages from components
 * @param component Component name or message prefix
 * @param message Message to log
 * @param data Optional data to include in the log
 */
export const debugLog = (message: string, data?: any) => {
  // Extract component name from the message if it includes a prefix
  const componentPrefix = message.includes(':') ? message.split(':')[0].trim() : null;
  const isComponentEnabled = componentPrefix && DEBUG_COMPONENTS[componentPrefix];
  
  // Log if global debug is enabled or this specific component is enabled
  if (DEBUG_ENABLED || isComponentEnabled) {
    console.log(`[Debug] ${message}`, data || '');
  }
};
